import log from '../../utils/logger.js'
import {AdBannerEvent, Empire} from '../../constants.js'

let cxf
let gameEventTrigger

const registerUpdatePay = () => {
    cxf.on(Empire.UPDATE_PAY, (eventData) => {
        const [serverResponse] = eventData
        const responseAsJSON = serverResponse[1]
        const paymentData = JSON.parse(responseAsJSON)
        gameEventTrigger(AdBannerEvent.UPDATE_PAY, paymentData)
    })
}

const registerCustomGameHandlers = (context, rootGameEventTrigger) => {
    log.debug(`EM - registerCustomGameHandlers`)
    cxf = context
    gameEventTrigger = rootGameEventTrigger

    registerUpdatePay()
}

const emController = {
    registerCustomGameHandlers
}

export default emController
